import { isEmpty } from '@/utils/is';
import { windowOpen } from '@/utils/utils';
import { isOffline } from '@/utils/deviceUtils/state';

import { isMonitorDevice } from '@/utils/deviceUtils';

import { popContextmenu } from '@/components/contextmenu/utils';
import { setDeviceCoordinate } from '@/layout/commonActions/setDeviceCoordinate/index.js';

import ctt from '@/utils/const/deviceType';

export function deviceContextMenu(event, data) {
  const { sn, deviceType } = data;

  if (isEmpty(data) || isEmpty(sn) || isEmpty(deviceType)) return;

  popContextmenu({
    x: event.clientX,
    y: event.clientY,
    appendToBody: false,
    container: this.$refs.container,
    menu: [
      {
        text: this.$t('查看设备详情'),
        event: () => {
          if (isOffline(data) && isMonitorDevice(data.runMode)) {
            return this.$message.warning('设备未连接');
          }

          this.$router.push({ name: 'Realdata', params: { sn, deviceType } });
        }
      },
      {
        text: this.$t('新窗口查看设备详情'),
        event: () => {
          if (isOffline(data) && isMonitorDevice(data.runMode)) {
            return this.$message.warning('设备未连接');
          }

          windowOpen({ name: 'Realdata', params: { sn, deviceType } }, sn);
        }
      },
      {
        text: this.$t('查看设备轨迹'),
        show: () => this.authMenu['01020201'] && [ctt.GD_606, ctt.GD_612].includes(deviceType),
        event: () => {
          if (isOffline(data) && isMonitorDevice(data.runMode)) {
            return this.$message.warning(this.$t('设备未连接'));
          }

          this.$router.push({ name: 'DeviceTrack', params: { sn, deviceType } });
        }
      },
      {
        text: this.$t('新窗口查看设备轨迹'),
        show: () => this.authMenu['01020201'] && [ctt.GD_606, ctt.GD_612].includes(deviceType),
        event: () => {
          if (isOffline(data) && isMonitorDevice(data.runMode)) {
            return this.$message.warning(this.$t('设备未连接'));
          }

          windowOpen({ name: 'DeviceTrack', params: { sn, deviceType } }, sn);
        }
      },
      {
        text: this.$t('设备信息编辑'),
        event: () => {
          console.log(data);

          setDeviceCoordinate({ deviceInfo: data, container: document.body });
        }
      }
    ]
  });
}
